import { useEffect, useState } from "react";
import { listNeckDiagrams, type SavedNeckDiagram } from "./api.js";

/** Search replaces the working set; stale pages never cross a newer search. */
export function useNeckDiagramLibrary() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState<{ diagrams: SavedNeckDiagram[]; nextOffset: number | null; canCreate: boolean; canPlay: boolean; canUseLibrary: boolean; instrument: import("@wmf/shared/neckDiagrams").InstrumentId | null; loading: boolean; error: string | null }>({ diagrams: [], nextOffset: null, canCreate: false, canPlay: false, canUseLibrary: false, instrument: null, loading: true, error: null });
  useEffect(() => {
    let current = true;
    setState(old => ({ ...old, loading: true, error: null, ...(page === 0 ? { diagrams: [] } : {}) }));
    const timer = window.setTimeout(() => {
      listNeckDiagrams(search, page).then(result => {
        if (current) setState(old => ({ ...result, diagrams: page === 0 ? result.diagrams : [...old.diagrams, ...result.diagrams.filter(row => !old.diagrams.some(saved => saved.id === row.id))], loading: false, error: null }));
      }).catch((error: unknown) => { if (current) setState(old => ({ ...old, loading: false, error: error instanceof Error ? error.message : "Could not load your diagrams." })); });
    }, search ? 200 : 0);
    return () => { current = false; window.clearTimeout(timer); };
  }, [search, page, revision]);
  return { ...state, search, setSearch: (value: string) => { setSearch(value); setPage(0); },
    reload: () => { setPage(0); setRevision(n => n + 1); }, loadMore: () => { if (!state.loading && state.nextOffset !== null) setPage(state.nextOffset); } };
}
